import { Controller } from "@hotwired/stimulus"

// Permet d'ajouter dynamiquement jusqu'à N options à un sondage préparé.
export default class extends Controller {
  static targets = ["optionsList"]
  static values  = { max: { type: Number, default: 5 } }

  addOption(event) {
    event.preventDefault()
    const current = this.optionsListTarget.querySelectorAll("input").length
    if (current >= this.maxValue) return

    const input = document.createElement("input")
    input.type = "text"
    input.name = "live_event_poll_template[options][]"
    input.placeholder = `Option ${current + 1}`
    input.maxLength = 120
    input.className = "input"
    this.optionsListTarget.appendChild(input)
    input.focus()
  }
}
